import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {CREATE_EXAM_REPORT, DELETE_EXAM_REPORT, FETCH_STUDENT_EXAM_REPORTS} from '../constants/exam-report';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_EXAM_REPORTS):
      return action.payload;

    case getSuccessActionType(CREATE_EXAM_REPORT):
      return [...state, action.payload];

    case getSuccessActionType(DELETE_EXAM_REPORT):
      return state.filter(examReport => examReport.id !== action.data.examReportId);

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_EXAM_REPORTS]),
  error: getErrorReducer([FETCH_STUDENT_EXAM_REPORTS]),
  data
});
